// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__dJ3GG","col":"styles_col__3sC5h","actions":"styles_actions__2FyQ5","conflict":"styles_conflict__3h_67"};